/*
 * Funduino Anleitungsbereich — Themenleiste und Panel.
 *
 * Kein Framework, keine Abhaengigkeit, auch nicht auf Horizons
 * Komponentensystem: Der Bereich soll ohne Eingriff in den Kern laufen, und
 * Horizons ref/on:-Bindungen gehoeren zum Kern.
 *
 * Nach dem Muster von assets/fu-mega-menu.js, aber deutlich kuerzer: Das
 * Anleitungs-Panel hat nur eine Liste, keine Schiene mit umschaltbaren
 * Rumpfen. Damit entfaellt der Roving-Tabindex, der dort noetig ist, und mit
 * ihm die halbe Tastatursteuerung.
 *
 * Zustand steht im Markup, nicht in Variablen: aria-expanded am Ausloeser,
 * hidden am Panel. Wer die Seite im Inspektor anhaelt, sieht denselben
 * Zustand, den das Skript kennt.
 *
 * EIN UNTERSCHIED ZUM SHOP-MENUE, BEWUSST
 * fu-mega-menu.js fragt data-menu-style am #header-component ab, weil Horizon
 * dort ueber Touch-Erkennung und Platzmangel entscheidet, ob Leiste oder
 * Drawer gilt. Auf den Anleitungsseiten ist der Horizon-Header ausgeblendet,
 * es gibt dieses Element also nicht. Hier zaehlt allein die Breite: ab 750px
 * die Leiste, darunter die Pillenreihe mit Drill-down (Schritt 6). Dieselbe
 * Grenze steht paarweise im CSS.
 */
(() => {
  if (window.__fuAnlMenu) return;
  window.__fuAnlMenu = true;

  const einrichten = (wurzel) => {
    if (wurzel.dataset.fuAnlReady === 'true') return;
    wurzel.dataset.fuAnlReady = 'true';

    const panels = new Map();
    wurzel.querySelectorAll('[data-fu-anl-panel]').forEach((p) => {
      panels.set(p.getAttribute('data-fu-anl-panel'), p);
    });
    if (!panels.size) return;

    let offen = null;

    /*
     * Sperre gegen das sofortige Wiederaufgehen nach Escape.
     *
     * Escape gibt den Fokus an den Ausloeser zurueck, damit die naechste
     * Tab-Taste dort weitermacht und nicht wieder oben auf der Seite
     * anfaengt. focus() loest aber synchron ein focusin aus — und genau
     * darauf oeffnet dieses Skript. Ohne die Sperre schloss Escape das Panel
     * und riss es im selben Wimpernschlag wieder auf.
     *
     * Die Sperre gilt nur fuer diesen einen Rueckgabe-Fokus und faellt im
     * naechsten Durchlauf der Ereignisschleife weg.
     */
    let escSperre = null;

    // Dieselbe Grenze wie in assets/fu-anl.css. Beide muessen zusammen
    // gelten, sonst reagiert ein unsichtbares Panel auf die Tastatur.
    const istLeiste = () => window.matchMedia('(min-width: 750px)').matches;

    const ausloeser = (key) => wurzel.querySelector('[data-fu-anl-trigger="' + key + '"]');

    const schliessen = () => {
      if (offen === null) return;
      const p = panels.get(offen);
      if (p) p.hidden = true;
      const t = ausloeser(offen);
      if (t) t.setAttribute('aria-expanded', 'false');
      offen = null;
    };

    const oeffnen = (key) => {
      if (!istLeiste()) return;
      if (escSperre === key) return;
      if (offen === key) return;
      const p = panels.get(key);
      if (!p) return;
      schliessen();
      p.hidden = false;
      const t = ausloeser(key);
      if (t) t.setAttribute('aria-expanded', 'true');
      offen = key;
    };

    /*
     * pointerover statt pointerenter: enter steigt nicht auf, over schon —
     * damit genuegt EIN Zuhoerer an der Wurzel fuer alle Themenpunkte.
     *
     * Nur die Maus oeffnet per Ueberfahren. Auf einem Touchgeraet loest der
     * erste Antipper sonst ein pointerover aus, das Panel geht auf, und der
     * Klick auf den Link darunter geht im selben Moment mit.
     */
    wurzel.addEventListener('pointerover', (e) => {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      const t = e.target.closest('[data-fu-anl-trigger]');
      if (t) oeffnen(t.getAttribute('data-fu-anl-trigger'));
    });

    /*
     * Derselbe Fall ueber die Tastatur. focusin steigt auf, focus nicht.
     *
     * Das Oeffnen beim blossen Fokussieren ist gewollt und entspricht
     * Horizons eigenem Menue: Wer die Leiste antabbt, sieht sofort, was
     * dahinter liegt. Weil das Panel im Markup direkt hinter seinem
     * Ausloeser steht, laeuft die naechste Tab-Taste hinein — ArrowDown ist
     * nur die Abkuerzung.
     */
    wurzel.addEventListener('focusin', (e) => {
      const t = e.target.closest('[data-fu-anl-trigger]');
      if (t) {
        oeffnen(t.getAttribute('data-fu-anl-trigger'));
        return;
      }
      /*
       * Fokus in der Leiste auf einem Punkt OHNE Panel — "Alle Anleitungen".
       * Ein noch offenes Panel eines anderen Punktes gehoert nicht zu dem,
       * was gerade fokussiert ist, und geht zu. Ohne diesen Zweig blieb es
       * stehen, wenn Tab aus dem letzten Link eines Panels genau auf so
       * einen Punkt lief: kein Ausloeser, kein neues oeffnen(), und focusout
       * sah den Fokus weiter innerhalb der Wurzel.
       */
      if (!e.target.closest('[data-fu-anl-panel]')) schliessen();
    });

    // Maus verlaesst den gesamten Bereich.
    wurzel.addEventListener('pointerleave', schliessen);

    /*
     * Verlassen per Tab. focusout meldet in relatedTarget, wohin der Fokus
     * geht; liegt das ausserhalb, ist das Panel durchlaufen. relatedTarget
     * ist null, wenn der Fokus das Fenster verlaesst — auch dann zu.
     */
    wurzel.addEventListener('focusout', (e) => {
      const ziel = e.relatedTarget;
      if (!ziel || !wurzel.contains(ziel)) schliessen();
    });

    /*
     * ArrowDown am Ausloeser oeffnet und springt auf den ersten Eintrag.
     * Nur ArrowDown, kein Enter und kein Space: Der Ausloeser ist ein Link
     * auf die Themenseite, und Enter muss ihm folgen — wer nur "Sensoren"
     * will, kommt so direkt hin.
     *
     * Das Ziel kommt aus aria-controls, also aus demselben Attribut, das
     * auch Hilfstechnik liest. Laufen Markup und Skript auseinander, faellt
     * das hier sofort auf.
     *
     * Escape schliesst und gibt den Fokus an den Ausloeser zurueck, sonst
     * steht er im Nichts und die naechste Tab-Taste beginnt wieder oben auf
     * der Seite.
     */
    wurzel.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        const t = e.target.closest('[data-fu-anl-trigger]');
        if (!t) return;
        const key = t.getAttribute('data-fu-anl-trigger');
        oeffnen(key);
        // Nicht aufgegangen — etwa unter 750px. Dann bleibt die Taste dem
        // Browser, damit die Seite wie ueberall sonst scrollt.
        if (offen !== key) return;
        e.preventDefault();
        const ziel = document.getElementById(t.getAttribute('aria-controls')) || panels.get(key);
        const erste = ziel ? ziel.querySelector('.fu-anl-mm__leaf-link') : null;
        if (erste) erste.focus();
        return;
      }

      if (e.key !== 'Escape' || offen === null) return;
      const t = ausloeser(offen);
      escSperre = offen;
      schliessen();
      if (t) t.focus();
      setTimeout(() => {
        escSperre = null;
      }, 0);
    });

    // Klick ausserhalb.
    document.addEventListener('click', (e) => {
      if (offen !== null && !wurzel.contains(e.target)) schliessen();
    });

    /*
     * Wird das Fenster unter die Grenze geschoben, gilt die Pillenreihe und
     * kein Panel darf offen stehenbleiben — es waere per CSS weg, aber sein
     * aria-expanded stuende weiter auf "true".
     */
    const schmal = window.matchMedia('(max-width: 749px)');
    const beiWechsel = (ev) => {
      if (ev.matches) schliessen();
    };
    if (typeof schmal.addEventListener === 'function') {
      schmal.addEventListener('change', beiWechsel);
    } else if (typeof schmal.addListener === 'function') {
      // Safari vor 14.
      schmal.addListener(beiWechsel);
    }
  };

  const alle = () => document.querySelectorAll('[data-fu-anl-mm]').forEach(einrichten);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  /*
   * Der Theme-Editor tauscht eine Section im laufenden Betrieb aus. Danach
   * ist die alte Wurzel samt ihrer Zuhoerer weg und die neue hat noch keine.
   */
  document.addEventListener('shopify:section:load', alle);
})();

/*
 * Suchvorschlaege.
 *
 * Holt sections/fu-anl-vorschlag.liquid ueber die Section-Rendering-API und
 * setzt das fertige HTML unter das Feld. Nicht ueber /search/suggest.json:
 * Der liefert keine Metafelder, und der Entwurf verlangt in der Zeile Bauzeit
 * und Schwierigkeit. Denselben Weg geht Horizons eigene Vorschlagssuche
 * (assets/predictive-search.js, getSectionHTML).
 *
 * Das Formular funktioniert auch ohne dieses Skript: Dann ist es ein
 * gewoehnliches Suchformular auf /search mit type=article.
 */
(() => {
  if (window.__fuAnlSuche) return;
  window.__fuAnlSuche = true;

  const SECTION = 'fu-anl-vorschlag';
  const WARTE = 200;
  const MINDEST = 2;

  const einrichten = (form) => {
    if (form.dataset.fuAnlSucheReady === 'true') return;
    form.dataset.fuAnlSucheReady = 'true';

    const feld = form.querySelector('[data-fu-anl-feld]');
    const kasten = form.querySelector('[data-fu-anl-vorschlag]');
    const loeschen = form.querySelector('[data-fu-anl-loeschen]');
    const route = form.getAttribute('data-fu-anl-route') || '/search/suggest';
    if (!feld || !kasten) return;

    let timer = null;
    let laufend = null;

    /*
     * Auf der Trefferseite steht der Begriff schon im Feld — dafuer setzt
     * snippets/fu-anl-suche.liquid das Kreuz bereits serverseitig sichtbar.
     * Hier steht dieselbe Zeile nur fuer den Fall, dass der Browser einen
     * Wert von sich aus zurueckbringt (Zurueck-Taste, Autofill): Dabei faellt
     * kein input-Ereignis an, und das Kreuz bliebe sonst weg.
     */
    if (loeschen) loeschen.hidden = feld.value.trim().length === 0;

    /*
     * aria-controls muss auf das Element mit role="listbox" zeigen, sonst
     * kuendigt das Feld ein Aufklappen an, dessen Ziel keine Rolle traegt.
     * Die Liste steht aber erst im HTML, das die Section liefert, und kann
     * ihre ID nicht selbst mitbringen: Dasselbe Suchfeld gibt es auf einer
     * Seite dreimal (Kopf, Drawer, Trefferseite), eine feste ID waere dreimal
     * dieselbe. Also vergibt das Skript sie je Formular und haengt
     * aria-controls um. Ohne Liste — leerer Kasten, Fehlanzeige — zeigt es
     * auf den Behaelter zurueck, damit es nie ins Leere verweist.
     */
    const listeId = kasten.id + '-liste';

    const zielHeften = () => {
      const liste = kasten.querySelector('[data-fu-anl-liste]');
      if (liste) {
        liste.id = listeId;
        feld.setAttribute('aria-controls', listeId);
      } else {
        feld.setAttribute('aria-controls', kasten.id);
      }
    };

    /*
     * aria-expanded haengt an der LISTE, nicht am Kasten. Der Kasten geht
     * auch bei einer Fehlanzeige auf — dann steht darin nur ein Satz und
     * keine Auswahl. Vorher meldete das Feld trotzdem "erweitert", und
     * aria-controls zeigte auf einen Behaelter ganz ohne Rolle: eine
     * Combobox, deren angekuendigtes Aufklappziel keine listbox ist, und in
     * der die Pfeiltaste keinen einzigen Eintrag findet. Was der Kasten in
     * diesem Fall zu sagen hat, sagt jetzt das role="status" darin
     * (sections/fu-anl-vorschlag.liquid).
     */
    const zeigen = (an) => {
      kasten.hidden = !an;
      const hatListe = !!kasten.querySelector('[data-fu-anl-liste]');
      feld.setAttribute('aria-expanded', an && hatListe ? 'true' : 'false');
    };

    const leeren = () => {
      kasten.innerHTML = '';
      zielHeften();
      zeigen(false);
    };

    const zeilen = () => Array.from(kasten.querySelectorAll('.fu-anl-vs__zeile'));

    /*
     * Ein Lauf je Tastendruck waere eine Anfrage je Buchstabe. Der
     * AbortController bricht die vorige ab, sobald eine neue faellig wird —
     * sonst kann eine langsame frueher Antwort die schnellere spaetere
     * ueberschreiben und die Liste zeigt Treffer zu einem Wort, das gar
     * nicht mehr im Feld steht.
     */
    const holen = (begriff) => {
      if (laufend) laufend.abort();
      laufend = new AbortController();

      const url = new URL(route, window.location.origin);
      url.searchParams.set('q', begriff);
      url.searchParams.set('section_id', SECTION);
      url.searchParams.set('resources[type]', 'article,product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'each');

      fetch(url.toString(), { signal: laufend.signal })
        .then((r) => (r.ok ? r.text() : null))
        .then((html) => {
          if (html === null) {
            leeren();
            return;
          }
          kasten.innerHTML = html;
          zielHeften();
          // Ein leeres Ergebnis kommt als leerer Rumpf zurueck. Dann bleibt
          // der Kasten zu, statt einen leeren Rahmen zu zeigen.
          zeigen(kasten.textContent.trim().length > 0);
        })
        .catch((e) => {
          // Ein Abbruch ist der Normalfall beim schnellen Tippen und kein
          // Fehler. Alles andere: Feld bleibt ein normales Suchformular.
          if (e && e.name === 'AbortError') return;
          leeren();
        });
    };

    const anstossen = () => {
      const begriff = feld.value.trim();
      loeschen.hidden = begriff.length === 0;

      if (timer) clearTimeout(timer);
      if (begriff.length < MINDEST) {
        if (laufend) laufend.abort();
        leeren();
        return;
      }
      timer = setTimeout(() => holen(begriff), WARTE);
    };

    feld.addEventListener('input', anstossen);

    // Beim Zurueckkehren auf die Seite steht der alte Text noch im Feld.
    feld.addEventListener('focus', () => {
      if (feld.value.trim().length >= MINDEST && kasten.innerHTML.trim()) zeigen(true);
    });

    loeschen.addEventListener('click', () => {
      feld.value = '';
      loeschen.hidden = true;
      leeren();
      feld.focus();
    });

    /*
     * Tastatur. ArrowDown steigt aus dem Feld in die Liste, danach laufen
     * ArrowUp und ArrowDown durch die Zeilen. Escape schliesst und laesst den
     * Fokus im Feld — anders als beim Panel, wo er zum Ausloeser zurueckgeht:
     * Hier IST das Feld der Ausgangspunkt, und wer die Vorschlaege wegdrueckt,
     * will meist weiterschreiben.
     *
     * Enter braucht keine Behandlung: Auf einer Zeile folgt der Browser dem
     * Link, im Feld schickt er das Formular ab.
     */
    form.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (kasten.hidden) return;
        e.preventDefault();
        zeigen(false);
        feld.focus();
        return;
      }

      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const liste = zeilen();
      if (!liste.length || kasten.hidden) return;

      const jetzt = liste.indexOf(document.activeElement);
      let i;
      if (jetzt < 0) {
        // Noch im Feld: nur ArrowDown steigt ein, ArrowUp bleibt dem Browser.
        if (e.key !== 'ArrowDown') return;
        i = 0;
      } else {
        i = e.key === 'ArrowDown' ? jetzt + 1 : jetzt - 1;
        // Kein Umlauf. Ueber der ersten Zeile geht es zurueck ins Feld —
        // sonst sitzt man in der Liste fest.
        if (i < 0) {
          e.preventDefault();
          feld.focus();
          return;
        }
        if (i >= liste.length) return;
      }
      e.preventDefault();
      liste[i].focus();
    });

    // Fokus verlaesst das Formular ganz.
    form.addEventListener('focusout', (e) => {
      const ziel = e.relatedTarget;
      if (!ziel || !form.contains(ziel)) zeigen(false);
    });

    // Klick ausserhalb.
    document.addEventListener('click', (e) => {
      if (!kasten.hidden && !form.contains(e.target)) zeigen(false);
    });
  };

  const alle = () => document.querySelectorAll('[data-fu-anl-suche]').forEach(einrichten);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', alle);
})();

/*
 * Funduino Anleitungsbereich — Drill-down auf dem Handy (Schritt 6).
 *
 * Unter 750px ersetzt eine scrollende Pillenreihe die Themenleiste. Eine
 * Pille mit Unterthemen oeffnet den Drill-down ueber der ganzen Flaeche.
 *
 * EIGENER BLOCK, NICHT IM PANEL-BLOCK
 * Die Panel-Mechanik oben steigt bei schmalem Fenster ausdruecklich aus
 * (istLeiste). Sie um einen zweiten Modus zu erweitern haette aus zwei
 * einfachen Zustandsmaschinen eine verschraenkte gemacht. Die beiden teilen
 * sich kein Markup und keinen Zustand — nur die Umbruchgrenze, und die steht
 * an beiden Stellen als dieselbe Zahl.
 *
 * ZUSTAND STEHT IM MARKUP
 * hidden am Drawer und an den Listen, aria-expanded an der Pille. Wie im
 * Panel-Block: Wer die Seite anhaelt, sieht denselben Zustand, den das
 * Skript kennt.
 *
 * OHNE SKRIPT
 * Bleibt die Pillenreihe sichtbar und der Drawer zu. Die Pillen mit
 * Unterthemen sind dann Knoepfe ohne Wirkung — deshalb traegt jedes Thema
 * seinen eigenen Verweis zusaetzlich als erste Zeile IM Drawer ("Alle in X
 * anzeigen"), und die Themenleiste ab 750px bleibt der vollstaendige Weg.
 */
(() => {
  if (window.__fuAnlDrill) return;
  window.__fuAnlDrill = true;

  const FOKUSSIERBAR =
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const einrichten = (wurzel) => {
    if (wurzel.dataset.fuAnlDrillReady === 'true') return;
    wurzel.dataset.fuAnlDrillReady = 'true';

    const drawer = wurzel.querySelector('[data-fu-anl-drawer]');
    const flaeche = wurzel.querySelector('.fu-anl-mm__dr-flaeche');
    const grund = wurzel.querySelector('[data-fu-anl-dr-grund]');
    const titel = wurzel.querySelector('[data-fu-anl-dr-titel]');
    const zurueck = wurzel.querySelector('[data-fu-anl-dr-zu]');
    const zeilen = wurzel.querySelectorAll('[data-fu-anl-drill]');
    const listen = wurzel.querySelectorAll('[data-fu-anl-dr-ebene]');
    const wurzelListe = wurzel.querySelector('[data-fu-anl-dr-ebene="wurzel"]');

    /* Der Hamburger steht im Kopf und nicht in diesem Element — die
       Tab-Reihenfolge verlangt ihn vor dem Inhalt (siehe den Kommentar an
       Ort und Stelle in sections/fu-anl-kopf.liquid). Deshalb der Umweg ueber
       den gemeinsamen Vorfahren; ohne ihn faende querySelector ihn nie. */
    const kopf = wurzel.closest('[data-fu-anl]') || document;
    const burger = kopf.querySelector('[data-fu-anl-burger]');

    if (!drawer || !flaeche || !titel || !wurzelListe || !burger) return;

    let letzterAusloeser = null;

    const schliessen = () => {
      if (drawer.hidden) return;
      drawer.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      zeilen.forEach((z) => z.setAttribute('aria-expanded', 'false'));
      burger.setAttribute('aria-expanded', 'false');
      listen.forEach((l) => (l.hidden = true));
      if (letzterAusloeser) {
        letzterAusloeser.focus();
        letzterAusloeser = null;
      }
    };

    /* Eine Ebene zeigen. name leer heisst Wurzelebene. */
    const zeigen = (liste, name) => {
      listen.forEach((l) => (l.hidden = l !== liste));
      titel.textContent = name || burgerName();

      /* Auf der Wurzelebene gibt es nichts, wohin der Pfeil zurueckfuehren
         koennte. Vor dem 09.09.2026 schloss er den Drawer — das war richtig,
         solange es nur eine Ebene gab, und waere jetzt eine Falle: Wer aus
         einem Thema zurueckwill, landete auf der Seite statt in der
         Themenliste. Das Kreuz daneben schliesst weiterhin. */
      if (zurueck) zurueck.hidden = !name;

      /* SICHTBAR heisst hier wirklich sichtbar.
       *
       * querySelector(FOKUSSIERBAR) allein traf auf der Wurzelebene den
       * versteckten Zurueck-Pfeil — ein hidden-Element passt weiter auf
       * 'button:not([disabled])'. focus() darauf tut nichts, und der Fokus
       * blieb still auf dem Hamburger AUSSERHALB des Drawers stehen. Bei
       * aria-modal="true" ist das ein echter Fehler: Der Fokus muss drin
       * sein, sonst fuehrt die erste Tabulatortaste hinter die Flaeche.
       *
       * offsetParent === null ist derselbe Test, den die Tabulatorschleife
       * weiter unten schon benutzt. Am 09.09.2026 nachgemessen. */
      const erstes = Array.from(flaeche.querySelectorAll(FOKUSSIERBAR)).find(
        (el) => el.offsetParent !== null
      );
      if (erstes) erstes.focus();
    };

    /* Die Ueberschrift der Wurzelebene.
     *
     * Sie kam bis zum 11.09.2026 aus dem Vorlesetext des Hamburgers. Das ging
     * gut, solange beide dasselbe Wort trugen — seit der Hamburger eine eigene
     * Beschriftung hat ("Menue") und der Drawer eine eigene Ueberschrift
     * ("Anleitungsthemen"), sind es zwei Angaben. Sie steht deshalb als
     * Datenmarke am Drawer, gesetzt von snippets/fu-anl-menu.liquid. */
    const burgerName = () => {
      const eigen = drawer.dataset.fuAnlWurzelTitel;
      if (eigen) return eigen.trim();
      const t = burger.querySelector('.visually-hidden');
      return t ? t.textContent.trim() : '';
    };

    const oeffnenWurzel = () => {
      letzterAusloeser = burger;
      zeilen.forEach((z) => z.setAttribute('aria-expanded', 'false'));
      burger.setAttribute('aria-expanded', 'true');

      drawer.hidden = false;
      /* Die Seite darunter darf nicht mitscrollen, solange der Drawer offen
         ist — sonst verliert man beim Zurueckgehen die Leseposition. */
      document.documentElement.style.overflow = 'hidden';

      zeigen(wurzelListe, '');
    };

    const oeffnenEbene = (zeile) => {
      const pos = zeile.dataset.fuAnlDrill;
      const liste = wurzel.querySelector('[data-fu-anl-dr-ebene="' + pos + '"]');
      if (!liste) return;

      zeilen.forEach((z) => z.setAttribute('aria-expanded', String(z === zeile)));

      const name = zeile.querySelector('span');
      zeigen(liste, name ? name.textContent : ' ');
    };

    burger.addEventListener('click', () => {
      if (burger.getAttribute('aria-expanded') === 'true') schliessen();
      else oeffnenWurzel();
    });

    zeilen.forEach((zeile) => {
      zeile.addEventListener('click', () => oeffnenEbene(zeile));
    });

    /* Der Pfeil geht eine Stufe zurueck, das Kreuz schliesst. */
    if (zurueck) {
      zurueck.addEventListener('click', () => zeigen(wurzelListe, ''));
    }

    wurzel.querySelectorAll('[data-fu-anl-dr-schliessen]').forEach((k) => {
      k.addEventListener('click', schliessen);
    });

    if (grund) grund.addEventListener('click', schliessen);

    /* aria-modal verspricht, dass nichts dahinter erreichbar ist. Ohne diese
       Schleife waere das eine Behauptung: Tab liefe weiter in die Seite. */
    flaeche.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const ziele = Array.from(flaeche.querySelectorAll(FOKUSSIERBAR)).filter(
        (el) => el.offsetParent !== null
      );
      if (ziele.length === 0) return;
      const erst = ziele[0];
      const letzt = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erst) {
        e.preventDefault();
        letzt.focus();
      } else if (!e.shiftKey && document.activeElement === letzt) {
        e.preventDefault();
        erst.focus();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) {
        e.stopPropagation();
        schliessen();
      }
    });

    /* Wird das Fenster breit, gilt wieder die Leiste. Ein offener Drawer
       haenge sonst unsichtbar ueber der Seite und hielte den Scroll fest. */
    const schmal = window.matchMedia('(max-width: 749px)');
    const wechsel = (e) => {
      if (!e.matches) schliessen();
    };
    if (schmal.addEventListener) schmal.addEventListener('change', wechsel);
    else if (schmal.addListener) schmal.addListener(wechsel);
  };

  const alle = () => document.querySelectorAll('[data-fu-anl-mm]').forEach(einrichten);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', alle);
})();
